import React, {useEffect, useState} from 'react'
import { ActionBtn } from './ActionBtn'
import { JobPostEdit } from './JobPostEdit'
import getLabelByValue from 'sr/helpers/functions/getLabelByValue'
import { individualJobStatus } from 'sr/i18n/messages/setting'
import { DateFormat } from 'sr/helpers/functions/DateFormat'
import { getJobType } from 'sr/utils/api/cleaner/getJobType'
import { updateJob } from 'sr/utils/api/individual/job/updateJob'
import { LoaderFullScreen } from 'sr/layout/common/LoaderFullScreen'
import { toast } from 'react-toastify'
import { Link } from 'react-router-dom'
import { StringTimeFormat } from 'sr/helpers/functions/StringTimeFormat'
import { getJobTypeCategory } from 'sr/utils/api/getJobTypeCategory'
import { FormattedMessage } from 'react-intl'
export const TableRow = ({item, setData}) => {
    const [editModel, setEditModel] = useState(false)
    const [loader, setLoader] = useState(false)
    const HandleModelByProps = (data) => {
        setEditModel(data)
       }
    const [jobTypes, setJobTypes] = useState([])
    useEffect(()=>{
      const fetchJobType = async ()=>{
try {
const res = await getJobTypeCategory()
if(res?.success===true){
  setJobTypes(res?.data)
}
}
catch(e:any){

}
      }
      fetchJobType()
    },[])
       const handleDelete = async ()=> {
        setLoader(true)
        try {
        const payload = {
                    id:item?.id,
                    status:'deleted'
        }
        const res = await updateJob(payload)
        if(res?.success===true){
setLoader(false)
setData((oldData)=>oldData?.filter((data)=>data?.id !== res?.data?.id))
toast.success('Deleted Successfully')

        }
        else {
            setLoader(false)
        }
    }
    catch(e){
            setLoader(false)
    }


       }


  return (
    <>
      {loader && <LoaderFullScreen />}
        <tr className="bg-white border-b  hover:bg-gray-50">
            <td className="w-4 p-4">
            {item?.work_status === 'open' ? (
              <Link to={`/individual/job-post-details/${item?.title}/${item?.id}`}> {item?.title}</Link>
            ) : jobTypes.length > 0 ? (
              <FormattedMessage id={getLabelByValue(item?.title || 'Unknown', jobTypes)}></FormattedMessage>
            ) : null}
            </td>
          
            <td className="px-6 py-4">
                {`${item?.streetAddress} ${item?.unitorapt}`}
            </td>
           
            <td className="px-6 py-4">
          {item?.rate ? `$${item?.rate?.toFixed(2)}`  : 'N/A'}
            </td>
    
            <td className="px-6 py-4">
            {DateFormat(item?.schedule_date)}
            </td>
            <td className="px-6 py-4">
            {StringTimeFormat(item?.start_time)}
            </td>
            <td className="px-6 py-4">
           
            {getLabelByValue(item?.work_status, individualJobStatus)}
            </td>
            <td className="px-6 py-4">
           
            <ActionBtn work_status={item?.work_status} deleteOnClick={handleDelete} jobId={item?.id}/>
           </td>   
        </tr>
        {editModel ?
    <JobPostEdit editModel={editModel} HandleModelByProps={HandleModelByProps}/>: null}
  </>)
}
